import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      height: 52,
      padding: theme.spacing(2, 0),
      borderBottom: `1px solid ${theme.palette.divider}`,

      '&:hover': {
        '& $name': {
          color: theme.palette.primary.main,
        },

        '& $actions': {
          visibility: 'visible',
        },
      },
    },
    content: {
      flex: '1',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    nameWrapper: {
      display: 'flex',
      alignItems: 'center',
      maxWidth: 'calc(100% - 120px)',
    },
    editButton: {
      marginLeft: theme.spacing(0.5),
      opacity: 0,
    },
    editIcon: {
      fontSize: theme.typography.pxToRem(20),
    },
    description: {
      maxWidth: '100%',
    },
    icon: {
      color: theme.palette.primary.main,
      marginRight: theme.spacing(0.5),
    },
    name: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      textAlign: 'left',
      wordBreak: 'break-word',
    },
    actions: {
      visibility: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginLeft: theme.spacing(1),
    },
    iconButton: {
      padding: '8px',

      '& svg': {
        fontSize: theme.typography.pxToRem(12),
        color: theme.palette.primary.main,
      },
    },
  }),
  { name: 'ProjectListItem' }
);
